import {call, put, takeEvery, takeLatest, delay} from 'redux-saga/effects';
import {START} from 'new-constants/app-state.constants';
import {checkConnection} from 'new-actions/api.actions.ts';
import {CHECK_CONNECTION_FAILURE, FAILURE_POSTFIX} from 'new-constants/api.constants';
import {SET_OFFLINE} from 'new-constants/connectivity.constants';

function* checkInitialConnection() {
	yield put(checkConnection());
}

function* recheckConnection(action) {
	yield delay(5000);
	yield put(checkConnection());
}

export const connectivitySaga = function* connectivitySaga() {
	yield takeEvery(START, checkInitialConnection);
	yield takeLatest([CHECK_CONNECTION_FAILURE, SET_OFFLINE], recheckConnection);
	yield takeLatest([action => action.type.endsWith(FAILURE_POSTFIX) && action.payload?.status !== 409], recheckConnection);
};
